export default {
    setUser(state: any, newData: any) {
        state.user = newData;
        //localStorage.setItem('user', JSON.stringify(newData));
    }
};
